<script lang="ts">
	import SignUpAffiliateLayout from '$lib/domain/layouts/SignUpAffiliateLayout.svelte'

	interface Props {
		children?: import('svelte').Snippet
	}

	let { children }: Props = $props()
</script>

<SignUpAffiliateLayout>
	{@render children?.()}
</SignUpAffiliateLayout>
